module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--confirm"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "title": "Reset Password",
      "copy": "Enter your new password.",
      "success-copy": "Password reset!",
      "slug": "confirm"
    }
  }, [_c('span', {
    attrs: {
      "slot": "link"
    },
    slot: "link"
  }, [_vm._v(_vm._s(_vm.status.success ? "" : "Remembered your password?") + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55cc37a2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Confirm.vue
// module id = 324
// module chunks = 0